import { Box, Button, Dialog, useTheme } from '@mui/material';
import CodeEditor from './CodeEditor';
import { useEffect, useRef, useState } from 'react';
import { API_PATCH, DBRequest, useConfig } from '../../api/api';
import { tokens } from '../../global/theme/tokens';
import TemplatePreview from '../templates/TemplatePreview';
import Loader from '../special/Loader';
import TemplateVariables from './templateEditor/TemplateVariables';
import Feedback from '../special/Feedback';
import ExoDialog from '../exo/ExoDialog';

const TemplateEditor = ({
  templateData,
  onSave = () => {},
  onClose = () => {},
  open = true,
  onFeedback = () => {},
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const aceEditorRef = useRef(null);

  const [template, setTemplate] = useState(templateData);
  const [currentKey, setCurrentKey] = useState('content');

  useEffect(() => {
    setTemplate(templateData);
  }, [templateData]);

  // ACTIONS --------
  function handleCodeChange(data) {
    setTemplate({
      ...template,
      [currentKey]: data,
    });
  }

  function handleHeightChange(page, headerHeight, footerHeight) {
    var newStyle = JSON.parse(template.styleJson);

    if (
      newStyle.page['headerP' + page + 'Height'] === headerHeight &&
      newStyle.page['footerP' + page + 'Height'] === footerHeight
    )
      return;
    newStyle.page['headerP' + page + 'Height'] = headerHeight;
    newStyle.page['footerP' + page + 'Height'] = footerHeight;

    setTemplate({
      ...template,
      styleJson: JSON.stringify(newStyle),
    });
  }

  function handleSectionSelect(section) {
    setCurrentKey(section);
  }

  const handleClickVariable = (textToInsert) => {
    const currentPos = aceEditorRef.current.editor.getCursorPosition();
    const text = aceEditorRef.current.editor.getValue();
    const beforeText = text.substring(
      0,
      aceEditorRef.current.editor.session.doc.positionToIndex(currentPos)
    );
    const afterText = text.substring(
      aceEditorRef.current.editor.session.doc.positionToIndex(currentPos),
      text.length
    );

    aceEditorRef.current.editor.setValue(beforeText + textToInsert + afterText);
    aceEditorRef.current.editor.clearSelection();
    aceEditorRef.current.editor.moveCursorToPosition(currentPos);
  };

  const config = useConfig();
  function handleSave() {
    DBRequest({
      config,
      path: 'templates/' + template.id,
      method: API_PATCH(template),
      onResponse: () => onSave(template),
      onFeedback: onFeedback,
    });
    onClose();
  }
  return (
    <ExoDialog open={open}>
      <Box className="flex flex-col h-full w-full">
        {!template.id ? (
          <Loader active={true} message="Template Loading..." />
        ) : (
          <Box className="flex flex-col h-full w-full overflow-y-auto justify-between">
            <Box className="flex flex-row h-full w-full overflow-hidden">
              <TemplateVariables
                className="min-w-[250px] max-w-[200px]"
                variables={template.vars}
                onClick={handleClickVariable}
              />
              <TemplatePreview
                edit={true}
                onSelect={handleSectionSelect}
                data={template}
                width="300"
                className="m-2 overflow-y-auto"
                paginate={true}
                background={true}
                onChange={handleHeightChange}
              />
              <CodeEditor
                className="w-full"
                editorRef={aceEditorRef}
                data={template[currentKey]}
                setData={handleCodeChange}
                height={500}
              />
            </Box>
            <Box
              className="flex justify-between p-2"
              sx={{
                backgroundColor: colors.card,
              }}
            >
              <Button color="error" onClick={onClose} variant="outlined">
                Cancel
              </Button>
              <Button color="success" variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </ExoDialog>
  );
};

export default TemplateEditor;
